import validator from "validator";

const aadharPattern = /^[2-9]{1}[0-9]{11}$/;
const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/i; // 'i' for case-insensitive
const UPIregex = /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{3,64}$/;

export const aadharValidation = (data) => {
  let errors = {};
  console.log("data", data);
  if (data?.aadharNumber.length !== 12) {
    errors.aadharNumber = "Aadhaar number must be 12 digits";
  } else if (!aadharPattern.test(data?.aadharNumber)) {
    errors.aadharNumber = "Invalid Aadhaar number";
  } else if (validator.isEmpty(data?.aadharPhoneNumber?.trim()))
    errors.aadharPhoneNumber = "Please enter mobile number";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const bankValidation = (data) => {
  let errors = {};
  if (!/^\d*$/.test(data.accountNum)) {
    errors.accountNum = "Account number must be numbers";
  } else if (data.accountNum.length < 9 || data.accountNum.length > 18) {
    errors.accountNum = "Account number must be 9 to 18 digits";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};
export const bankIFSCValidation = (data) => {
  let errors = {};
  console.log(31, data.ifscCode, ifscPattern.test(data.ifscCode))
  if (!ifscPattern.test(data.ifscCode)) {
    errors.ifscCode = "Invalid IFSC code format (e.g., SBIN0123456)";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const bankDetailsValidation = (data) => {
  let errors = {};
  

  if (!data?.transactionId || validator.isEmpty(data?.transactionId)) {
    errors.transactionId = "Please enter transaction Id";
  } else {

  }
  if (!data?.remark || validator.isEmpty(data?.remark)) {
    errors.remark = "Please enter remark";
  } else {

  }

  // if (!data?.accHolderName || validator.isEmpty(data?.accHolderName)) {
  //   errors.accHolderName = "Please enter account holder name";
  // } else {
    
  // }
  // if (!data?.bankName || validator.isEmpty(data?.bankName)) {
  //   errors.bankName = "Please enter bank name";
  // } else {
  
  // }
  // if (!data?.accNumber || validator.isEmpty(data?.accNumber)) {
    
  //   errors.accNumber = "Please enter account number";
  // } else {
    
  // }
  // if (!data?.ifscCode || validator.isEmpty(data?.ifscCode)) {
    
  //   errors.ifscCode = "Please enter IFSC code";
  // } 
  // if (!ifscPattern.test(data.ifscCode)) {
  //   errors.ifscCode = "Invalid IFSC code format (e.g., SBIN0123456)";
  // }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};


export const bankDetailsValidation2 = (data) => {
  let errors = {};
  

 
 

  if (!data?.accHolderName || validator.isEmpty(data?.accHolderName)) {
    errors.accHolderName = "Please enter account holder name";
  } else {
    
  }
  if (!data?.bankName || validator.isEmpty(data?.bankName)) {
    errors.bankName = "Please enter bank name";
  } else {
  
  }
  if (!data?.accNumber || validator.isEmpty(data?.accNumber)) {
    
    errors.accNumber = "Please enter account number";
  } else {
    
  }
  if (!data?.ifscCode || validator.isEmpty(data?.ifscCode)) {
    
    errors.ifscCode = "Please enter IFSC code";
  } 
  if (!ifscPattern.test(data.ifscCode)) {
    errors.ifscCode = "Invalid IFSC code format (e.g., SBIN0123456)";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};


export const bankDetailsValidationWithdraw = (data) => {
  let errors = {};
  

  

  if (!data?.accHolderName || validator.isEmpty(data?.accHolderName)) {
    errors.accHolderName = "Please enter account holder name";
  } else {
    
  }
  if (!data?.bankName || validator.isEmpty(data?.bankName)) {
    errors.bankName = "Please enter bank name";
  } else {
  
  }
  if (!data?.accNumber || validator.isEmpty(data?.accNumber)) {
    
    errors.accNumber = "Please enter account number";
  } else {
    
  }
  if (!data?.ifscCode || validator.isEmpty(data?.ifscCode)) {
    
    errors.ifscCode = "Please enter IFSC code";
  } 
  if (!ifscPattern.test(data.ifscCode)) {
    errors.ifscCode = "Invalid IFSC code format (e.g., SBIN0123456)";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const UPIValidationWithdraw = (data) => {
  let errors = {};
 
  if (!UPIregex.test(data.upi)) {
    errors.upi = "Invalid UPI code";
  }

  
  return { errors, isValid: Object.keys(errors).length <= 0 };
};
export const UPIValidation = (data) => {
  let errors = {};
 
  // if (!UPIregex.test(data.upi)) {
  //   errors.upi = "Invalid UPI code";
  // }

  if (!data?.transactionId || validator.isEmpty(data?.transactionId)) {
    errors.transactionId = "Please enter transaction Id";
  } else {

  }
  if (!data?.remark || validator.isEmpty(data?.remark)) {
    errors.remark = "Please enter remark";
  } else {

  }
  return { errors, isValid: Object.keys(errors).length <= 0 };
};